import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ImportExportStats, Statistic, StatisticPerimeter } from '../_models/statistics';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class StatisticService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getAll() {
    return this.http.get<Statistic>(`${environment.apiUrl}/Statistics/all`, { headers: this.authService.headers });
  }

  getImportExportStats() {
    return this.http.get<ImportExportStats>(`${environment.apiUrl}/Statistics/statImportExport`, { headers: this.authService.headers });
  }

  getStatAdherents() {
    return this.http.get<Statistic[]>(`${environment.apiUrl}/Statistics/Adherents`, { headers: this.authService.headers });
  }

  GetuserForAcdStatistics() {
    return this.http.get<Statistic[]>(`${environment.apiUrl}/Statistics/usersforacd`, { headers: this.authService.headers });
  }

  getResourcesExport() {
    return this.http.get<Blob>(`${environment.apiUrl}/Statistics/ressources/xlsx`, { headers: this.authService.headers, responseType: 'blob' as 'json' });
  }

  getAdherentsStatsExportExcel(startDate: string | null, endDate: string | null) {
    return this.http.get<Blob>(`${environment.apiUrl}/Statistics/adherentsExcelStat/xlsx?startDate=` + startDate + `&endDate=` + endDate, { headers: this.authService.headers, responseType: 'blob' as 'json' });
  }

  getStatsExportExcel() {
    return this.http.get<Blob>(`${environment.apiUrl}/Statistics/statExcelSheet/xlsx`, { headers: this.authService.headers, responseType: 'blob' as 'json' });
  }

  getUsagesExport(startDate: string | null, endDate: string | null) {
    if (startDate != undefined && endDate != undefined) return this.http.get<Blob>(`${environment.apiUrl}/Statistics/usages/xlsx?startDate=` + startDate + `&endDate=` + endDate, { headers: this.authService.headers, responseType: 'blob' as 'json' });
    else return this.http.get<Blob>(`${environment.apiUrl}/Statistics/usages/xlsx`, { headers: this.authService.headers, responseType: 'blob' as 'json' });
  }

  getSolutionsPerimeters() {
    return this.http.get<StatisticPerimeter[]>(`${environment.apiUrl}/Statistics/statSolutionsPerimeters`, { headers: this.authService.headers });
  }

  getSolutionsUsagesExport(startDate: string | null, endDate: string | null, perimeterIds: string[] = []) {
    let params = new HttpParams();
    if (startDate != undefined && endDate != undefined) params = params.set('startDate', startDate).set('endDate', endDate);
    perimeterIds.forEach((id) => (params = params.append('perimeterIds', id)));
    return this.http.get<Blob>(`${environment.apiUrl}/Statistics/statSolutionsExcelSheet/xlsx`, { params: params, headers: this.authService.headers, responseType: 'blob' as 'json' });
  }
}
